// extracted by mini-css-extract-plugin
module.exports = {"my-tree-box":"style_my-tree-box__35ttJ","my-tree-box-spin":"style_my-tree-box-spin__6TtbV"};